// TODO: remplacer par les icônes de la librairie, ceci est un export des icônes de Smily (FontAwesome)
export default {
  data() {
    return {
      iconFaConst: [
        {icon: 'fa-adjust', label: 'fa-adjust'},
        {icon: 'fa-adn', label: 'fa-adn'},
        {icon: 'fa-align-center', label: 'fa-align-center'},
        {icon: 'fa-align-justify', label: 'fa-align-justify'},
        {icon: 'fa-align-left', label: 'fa-align-left'},
        {icon: 'fa-align-right', label: 'fa-align-right'},
        {icon: 'fa-ambulance', label: 'fa-ambulance'},
        {icon: 'fa-anchor', label: 'fa-anchor'},
        {icon: 'fa-android', label: 'fa-android'},
        {icon: 'fa-angle-double-down', label: 'fa-angle-double-down'},
        {icon: 'fa-angle-double-left', label: 'fa-angle-double-left'},
        {icon: 'fa-angle-double-right', label: 'fa-angle-double-right'},
        {icon: 'fa-angle-double-up', label: 'fa-angle-double-up'},
        {icon: 'fa-angle-down', label: 'fa-angle-down'},
        {icon: 'fa-angle-left', label: 'fa-angle-left'},
        {icon: 'fa-angle-right', label: 'fa-angle-right'},
        {icon: 'fa-angle-up', label: 'fa-angle-up'},
        {icon: 'fa-apple', label: 'fa-apple'},
        {icon: 'fa-archive', label: 'fa-archive'},
        {icon: 'fa-arrow-circle-down', label: 'fa-arrow-circle-down'},
        {icon: 'fa-arrow-circle-left', label: 'fa-arrow-circle-left'},
        {icon: 'fa-arrow-circle-o-down', label: 'fa-arrow-circle-o-down'},
        {icon: 'fa-arrow-circle-o-left', label: 'fa-arrow-circle-o-left'},
        {icon: 'fa-arrow-circle-o-right', label: 'fa-arrow-circle-o-right'},
        {icon: 'fa-arrow-circle-o-up', label: 'fa-arrow-circle-o-up'},
        {icon: 'fa-arrow-circle-right', label: 'fa-arrow-circle-right'},
        {icon: 'fa-arrow-circle-up', label: 'fa-arrow-circle-up'},
        {icon: 'fa-arrow-down', label: 'fa-arrow-down'},
        {icon: 'fa-arrow-left', label: 'fa-arrow-left'},
        {icon: 'fa-arrow-right', label: 'fa-arrow-right'},
        {icon: 'fa-arrow-up', label: 'fa-arrow-up'},
        {icon: 'fa-arrows', label: 'fa-arrows'},
        {icon: 'fa-arrows-alt', label: 'fa-arrows-alt'},
        {icon: 'fa-arrows-h', label: 'fa-arrows-h'},
        {icon: 'fa-arrows-v', label: 'fa-arrows-v'},
        {icon: 'fa-asterisk', label: 'fa-asterisk'},
        {icon: 'fa-automobile', label: 'fa-automobile'},
        {icon: 'fa-backward', label: 'fa-backward'},
        {icon: 'fa-ban', label: 'fa-ban'},
        {icon: 'fa-bank', label: 'fa-bank'},
        {icon: 'fa-bar-chart-o', label: 'fa-bar-chart-o'},
        {icon: 'fa-barcode', label: 'fa-barcode'},
        {icon: 'fa-bars', label: 'fa-bars'},
        {icon: 'fa-beer', label: 'fa-beer'},
        {icon: 'fa-behance', label: 'fa-behance'},
        {icon: 'fa-behance-square', label: 'fa-behance-square'},
        {icon: 'fa-bell', label: 'fa-bell'},
        {icon: 'fa-bell-o', label: 'fa-bell-o'},
        {icon: 'fa-bitbucket', label: 'fa-bitbucket'},
        {icon: 'fa-bitbucket-square', label: 'fa-bitbucket-square'},
        {icon: 'fa-bitcoin', label: 'fa-bitcoin'},
        {icon: 'fa-bold', label: 'fa-bold'},
        {icon: 'fa-bolt', label: 'fa-bolt'},
        {icon: 'fa-bomb', label: 'fa-bomb'},
        {icon: 'fa-book', label: 'fa-book'},
        {icon: 'fa-bookmark', label: 'fa-bookmark'},
        {icon: 'fa-bookmark-o', label: 'fa-bookmark-o'},
        {icon: 'fa-briefcase', label: 'fa-briefcase'},
        {icon: 'fa-btc', label: 'fa-btc'},
        {icon: 'fa-bug', label: 'fa-bug'},
        {icon: 'fa-building', label: 'fa-building'},
        {icon: 'fa-building-o', label: 'fa-building-o'},
        {icon: 'fa-bullhorn', label: 'fa-bullhorn'},
        {icon: 'fa-bullseye', label: 'fa-bullseye'},
        {icon: 'fa-cab', label: 'fa-cab'},
        {icon: 'fa-calendar', label: 'fa-calendar'},
        {icon: 'fa-calendar-o', label: 'fa-calendar-o'},
        {icon: 'fa-camera', label: 'fa-camera'},
        {icon: 'fa-camera-retro', label: 'fa-camera-retro'},
        {icon: 'fa-car', label: 'fa-car'},
        {icon: 'fa-caret-down', label: 'fa-caret-down'},
        {icon: 'fa-caret-left', label: 'fa-caret-left'},
        {icon: 'fa-caret-right', label: 'fa-caret-right'},
        {icon: 'fa-caret-square-o-down', label: 'fa-caret-square-o-down'},
        {icon: 'fa-caret-square-o-left', label: 'fa-caret-square-o-left'},
        {icon: 'fa-caret-square-o-right', label: 'fa-caret-square-o-right'},
        {icon: 'fa-caret-square-o-up', label: 'fa-caret-square-o-up'},
        {icon: 'fa-caret-up', label: 'fa-caret-up'},
        {icon: 'fa-certificate', label: 'fa-certificate'},
        {icon: 'fa-chain', label: 'fa-chain'},
        {icon: 'fa-chain-broken', label: 'fa-chain-broken'},
        {icon: 'fa-check', label: 'fa-check'},
        {icon: 'fa-check-circle', label: 'fa-check-circle'},
        {icon: 'fa-check-circle-o', label: 'fa-check-circle-o'},
        {icon: 'fa-check-square', label: 'fa-check-square'},
        {icon: 'fa-check-square-o', label: 'fa-check-square-o'},
        {icon: 'fa-chevron-circle-down', label: 'fa-chevron-circle-down'},
        {icon: 'fa-chevron-circle-left', label: 'fa-chevron-circle-left'},
        {icon: 'fa-chevron-circle-right', label: 'fa-chevron-circle-right'},
        {icon: 'fa-chevron-circle-up', label: 'fa-chevron-circle-up'},
        {icon: 'fa-chevron-down', label: 'fa-chevron-down'},
        {icon: 'fa-chevron-left', label: 'fa-chevron-left'},
        {icon: 'fa-chevron-right', label: 'fa-chevron-right'},
        {icon: 'fa-chevron-up', label: 'fa-chevron-up'},
        {icon: 'fa-child', label: 'fa-child'},
        {icon: 'fa-circle', label: 'fa-circle'},
        {icon: 'fa-circle-o', label: 'fa-circle-o'},
        {icon: 'fa-circle-o-notch', label: 'fa-circle-o-notch'},
        {icon: 'fa-circle-thin', label: 'fa-circle-thin'},
        {icon: 'fa-clipboard', label: 'fa-clipboard'},
        {icon: 'fa-clock-o', label: 'fa-clock-o'},
        {icon: 'fa-cloud', label: 'fa-cloud'},
        {icon: 'fa-cloud-download', label: 'fa-cloud-download'},
        {icon: 'fa-cloud-upload', label: 'fa-cloud-upload'},
        {icon: 'fa-cny', label: 'fa-cny'},
        {icon: 'fa-code', label: 'fa-code'},
        {icon: 'fa-code-fork', label: 'fa-code-fork'},
        {icon: 'fa-codepen', label: 'fa-codepen'},
        {icon: 'fa-coffee', label: 'fa-coffee'},
        {icon: 'fa-cog', label: 'fa-cog'},
        {icon: 'fa-cogs', label: 'fa-cogs'},
        {icon: 'fa-columns', label: 'fa-columns'},
        {icon: 'fa-comment', label: 'fa-comment'},
        {icon: 'fa-comment-o', label: 'fa-comment-o'},
        {icon: 'fa-comments', label: 'fa-comments'},
        {icon: 'fa-comments-o', label: 'fa-comments-o'},
        {icon: 'fa-compass', label: 'fa-compass'},
        {icon: 'fa-compress', label: 'fa-compress'},
        {icon: 'fa-copy', label: 'fa-copy'},
        {icon: 'fa-credit-card', label: 'fa-credit-card'},
        {icon: 'fa-crop', label: 'fa-crop'},
        {icon: 'fa-crosshairs', label: 'fa-crosshairs'},
        {icon: 'fa-css', label: 'fa-css'},
        {icon: 'fa-cube', label: 'fa-cube'},
        {icon: 'fa-cubes', label: 'fa-cubes'},
        {icon: 'fa-cut', label: 'fa-cut'},
        {icon: 'fa-cutlery', label: 'fa-cutlery'},
        {icon: 'fa-dashboard', label: 'fa-dashboard'},
        {icon: 'fa-database', label: 'fa-database'},
        {icon: 'fa-dedent', label: 'fa-dedent'},
        {icon: 'fa-delicious', label: 'fa-delicious'},
        {icon: 'fa-desktop', label: 'fa-desktop'},
        {icon: 'fa-deviantart', label: 'fa-deviantart'},
        {icon: 'fa-digg', label: 'fa-digg'},
        {icon: 'fa-dollar', label: 'fa-dollar'},
        {icon: 'fa-dot-circle-o', label: 'fa-dot-circle-o'},
        {icon: 'fa-download', label: 'fa-download'},
        {icon: 'fa-dribbble', label: 'fa-dribbble'},
        {icon: 'fa-dropbox', label: 'fa-dropbox'},
        {icon: 'fa-drupal', label: 'fa-drupal'},
        {icon: 'fa-edit', label: 'fa-edit'},
        {icon: 'fa-eject', label: 'fa-eject'},
        {icon: 'fa-ellipsis-h', label: 'fa-ellipsis-h'},
        {icon: 'fa-ellipsis-v', label: 'fa-ellipsis-v'},
        {icon: 'fa-empire', label: 'fa-empire'},
        {icon: 'fa-envelope', label: 'fa-envelope'},
        {icon: 'fa-envelope-o', label: 'fa-envelope-o'},
        {icon: 'fa-envelope-square', label: 'fa-envelope-square'},
        {icon: 'fa-eraser', label: 'fa-eraser'},
        {icon: 'fa-eur', label: 'fa-eur'},
        {icon: 'fa-euro', label: 'fa-euro'},
        {icon: 'fa-exchange', label: 'fa-exchange'},
        {icon: 'fa-exclamation', label: 'fa-exclamation'},
        {icon: 'fa-exclamation-circle', label: 'fa-exclamation-circle'},
        {icon: 'fa-exclamation-triangle', label: 'fa-exclamation-triangle'},
        {icon: 'fa-expand', label: 'fa-expand'},
        {icon: 'fa-external-link', label: 'fa-external-link'},
        {icon: 'fa-external-link-square', label: 'fa-external-link-square'},
        {icon: 'fa-eye', label: 'fa-eye'},
        {icon: 'fa-eye-slash', label: 'fa-eye-slash'},
        {icon: 'fa-facebook', label: 'fa-facebook'},
        {icon: 'fa-facebook-square', label: 'fa-facebook-square'},
        {icon: 'fa-fast-backward', label: 'fa-fast-backward'},
        {icon: 'fa-fast-forward', label: 'fa-fast-forward'},
        {icon: 'fa-fax', label: 'fa-fax'},
        {icon: 'fa-female', label: 'fa-female'},
        {icon: 'fa-fighter-jet', label: 'fa-fighter-jet'},
        {icon: 'fa-file', label: 'fa-file'},
        {icon: 'fa-file-archive-o', label: 'fa-file-archive-o'},
        {icon: 'fa-file-audio-o', label: 'fa-file-audio-o'},
        {icon: 'fa-file-code-o', label: 'fa-file-code-o'},
        {icon: 'fa-file-excel-o', label: 'fa-file-excel-o'},
        {icon: 'fa-file-image-o', label: 'fa-file-image-o'},
        {icon: 'fa-file-movie-o', label: 'fa-file-movie-o'},
        {icon: 'fa-file-o', label: 'fa-file-o'},
        {icon: 'fa-file-pdf-o', label: 'fa-file-pdf-o'},
        {icon: 'fa-file-photo-o', label: 'fa-file-photo-o'},
        {icon: 'fa-file-picture-o', label: 'fa-file-picture-o'},
        {icon: 'fa-file-powerpoint-o', label: 'fa-file-powerpoint-o'},
        {icon: 'fa-file-sound-o', label: 'fa-file-sound-o'},
        {icon: 'fa-file-text', label: 'fa-file-text'},
        {icon: 'fa-file-text-o', label: 'fa-file-text-o'},
        {icon: 'fa-file-video-o', label: 'fa-file-video-o'},
        {icon: 'fa-file-word-o', label: 'fa-file-word-o'},
        {icon: 'fa-file-zip-o', label: 'fa-file-zip-o'},
        {icon: 'fa-files-o', label: 'fa-files-o'},
        {icon: 'fa-film', label: 'fa-film'},
        {icon: 'fa-filter', label: 'fa-filter'},
        {icon: 'fa-fire', label: 'fa-fire'},
        {icon: 'fa-fire-extinguisher', label: 'fa-fire-extinguisher'},
        {icon: 'fa-flag', label: 'fa-flag'},
        {icon: 'fa-flag-checkered', label: 'fa-flag-checkered'},
        {icon: 'fa-flag-o', label: 'fa-flag-o'},
        {icon: 'fa-flash', label: 'fa-flash'},
        {icon: 'fa-flask', label: 'fa-flask'},
        {icon: 'fa-flickr', label: 'fa-flickr'},
        {icon: 'fa-floppy-o', label: 'fa-floppy-o'},
        {icon: 'fa-folder', label: 'fa-folder'},
        {icon: 'fa-folder-o', label: 'fa-folder-o'},
        {icon: 'fa-folder-open', label: 'fa-folder-open'},
        {icon: 'fa-folder-open-o', label: 'fa-folder-open-o'},
        {icon: 'fa-font', label: 'fa-font'},
        {icon: 'fa-forward', label: 'fa-forward'},
        {icon: 'fa-foursquare', label: 'fa-foursquare'},
        {icon: 'fa-frown-o', label: 'fa-frown-o'},
        {icon: 'fa-gamepad', label: 'fa-gamepad'},
        {icon: 'fa-gavel', label: 'fa-gavel'},
        {icon: 'fa-gbp', label: 'fa-gbp'},
        {icon: 'fa-ge', label: 'fa-ge'},
        {icon: 'fa-gear', label: 'fa-gear'},
        {icon: 'fa-gears', label: 'fa-gears'},
        {icon: 'fa-gift', label: 'fa-gift'},
        {icon: 'fa-git', label: 'fa-git'},
        {icon: 'fa-git-square', label: 'fa-git-square'},
        {icon: 'fa-github', label: 'fa-github'},
        {icon: 'fa-github-alt', label: 'fa-github-alt'},
        {icon: 'fa-github-square', label: 'fa-github-square'},
        {icon: 'fa-gittip', label: 'fa-gittip'},
        {icon: 'fa-glass', label: 'fa-glass'},
        {icon: 'fa-globe', label: 'fa-globe'},
        {icon: 'fa-google', label: 'fa-google'},
        {icon: 'fa-google-plus', label: 'fa-google-plus'},
        {icon: 'fa-google-plus-square', label: 'fa-google-plus-square'},
        {icon: 'fa-graduation-cap', label: 'fa-graduation-cap'},
        {icon: 'fa-group', label: 'fa-group'},
        {icon: 'fa-h-square', label: 'fa-h-square'},
        {icon: 'fa-hacker-news', label: 'fa-hacker-news'},
        {icon: 'fa-hand-o-down', label: 'fa-hand-o-down'},
        {icon: 'fa-hand-o-left', label: 'fa-hand-o-left'},
        {icon: 'fa-hand-o-right', label: 'fa-hand-o-right'},
        {icon: 'fa-hand-o-up', label: 'fa-hand-o-up'},
        {icon: 'fa-hdd-o', label: 'fa-hdd-o'},
        {icon: 'fa-header', label: 'fa-header'},
        {icon: 'fa-headphones', label: 'fa-headphones'},
        {icon: 'fa-heart', label: 'fa-heart'},
        {icon: 'fa-heart-o', label: 'fa-heart-o'},
        {icon: 'fa-history', label: 'fa-history'},
        {icon: 'fa-home', label: 'fa-home'},
        {icon: 'fa-hospital-o', label: 'fa-hospital-o'},
        {icon: 'fa-html', label: 'fa-html'},
        {icon: 'fa-image', label: 'fa-image'},
        {icon: 'fa-inbox', label: 'fa-inbox'},
        {icon: 'fa-indent', label: 'fa-indent'},
        {icon: 'fa-info', label: 'fa-info'},
        {icon: 'fa-info-circle', label: 'fa-info-circle'},
        {icon: 'fa-inr', label: 'fa-inr'},
        {icon: 'fa-instagram', label: 'fa-instagram'},
        {icon: 'fa-institution', label: 'fa-institution'},
        {icon: 'fa-italic', label: 'fa-italic'},
        {icon: 'fa-joomla', label: 'fa-joomla'},
        {icon: 'fa-jpy', label: 'fa-jpy'},
        {icon: 'fa-jsfiddle', label: 'fa-jsfiddle'},
        {icon: 'fa-key', label: 'fa-key'},
        {icon: 'fa-keyboard-o', label: 'fa-keyboard-o'},
        {icon: 'fa-krw', label: 'fa-krw'},
        {icon: 'fa-language', label: 'fa-language'},
        {icon: 'fa-laptop', label: 'fa-laptop'},
        {icon: 'fa-leaf', label: 'fa-leaf'},
        {icon: 'fa-legal', label: 'fa-legal'},
        {icon: 'fa-lemon-o', label: 'fa-lemon-o'},
        {icon: 'fa-level-down', label: 'fa-level-down'},
        {icon: 'fa-level-up', label: 'fa-level-up'},
        {icon: 'fa-life-bouy', label: 'fa-life-bouy'},
        {icon: 'fa-life-ring', label: 'fa-life-ring'},
        {icon: 'fa-life-saver', label: 'fa-life-saver'},
        {icon: 'fa-lightbulb-o', label: 'fa-lightbulb-o'},
        {icon: 'fa-link', label: 'fa-link'},
        {icon: 'fa-linkedin', label: 'fa-linkedin'},
        {icon: 'fa-linkedin-square', label: 'fa-linkedin-square'},
        {icon: 'fa-linux', label: 'fa-linux'},
        {icon: 'fa-list', label: 'fa-list'},
        {icon: 'fa-list-alt', label: 'fa-list-alt'},
        {icon: 'fa-list-ol', label: 'fa-list-ol'},
        {icon: 'fa-list-ul', label: 'fa-list-ul'},
        {icon: 'fa-location-arrow', label: 'fa-location-arrow'},
        {icon: 'fa-lock', label: 'fa-lock'},
        {icon: 'fa-long-arrow-down', label: 'fa-long-arrow-down'},
        {icon: 'fa-long-arrow-left', label: 'fa-long-arrow-left'},
        {icon: 'fa-long-arrow-right', label: 'fa-long-arrow-right'},
        {icon: 'fa-long-arrow-up', label: 'fa-long-arrow-up'},
        {icon: 'fa-magic', label: 'fa-magic'},
        {icon: 'fa-magnet', label: 'fa-magnet'},
        {icon: 'fa-mail-forward', label: 'fa-mail-forward'},
        {icon: 'fa-mail-reply', label: 'fa-mail-reply'},
        {icon: 'fa-mail-reply-all', label: 'fa-mail-reply-all'},
        {icon: 'fa-male', label: 'fa-male'},
        {icon: 'fa-map-marker', label: 'fa-map-marker'},
        {icon: 'fa-maxcdn', label: 'fa-maxcdn'},
        {icon: 'fa-medkit', label: 'fa-medkit'},
        {icon: 'fa-meh-o', label: 'fa-meh-o'},
        {icon: 'fa-microphone', label: 'fa-microphone'},
        {icon: 'fa-microphone-slash', label: 'fa-microphone-slash'},
        {icon: 'fa-minus', label: 'fa-minus'},
        {icon: 'fa-minus-circle', label: 'fa-minus-circle'},
        {icon: 'fa-minus-square', label: 'fa-minus-square'},
        {icon: 'fa-minus-square-o', label: 'fa-minus-square-o'},
        {icon: 'fa-mobile', label: 'fa-mobile'},
        {icon: 'fa-mobile-phone', label: 'fa-mobile-phone'},
        {icon: 'fa-money', label: 'fa-money'},
        {icon: 'fa-moon-o', label: 'fa-moon-o'},
        {icon: 'fa-mortar-board', label: 'fa-mortar-board'},
        {icon: 'fa-music', label: 'fa-music'},
        {icon: 'fa-navicon', label: 'fa-navicon'},
        {icon: 'fa-openid', label: 'fa-openid'},
        {icon: 'fa-outdent', label: 'fa-outdent'},
        {icon: 'fa-pagelines', label: 'fa-pagelines'},
        {icon: 'fa-paper-plane', label: 'fa-paper-plane'},
        {icon: 'fa-paper-plane-o', label: 'fa-paper-plane-o'},
        {icon: 'fa-paperclip', label: 'fa-paperclip'},
        {icon: 'fa-paragraph', label: 'fa-paragraph'},
        {icon: 'fa-paste', label: 'fa-paste'},
        {icon: 'fa-pause', label: 'fa-pause'},
        {icon: 'fa-paw', label: 'fa-paw'},
        {icon: 'fa-pencil', label: 'fa-pencil'},
        {icon: 'fa-pencil-square', label: 'fa-pencil-square'},
        {icon: 'fa-pencil-square-o', label: 'fa-pencil-square-o'},
        {icon: 'fa-phone', label: 'fa-phone'},
        {icon: 'fa-phone-square', label: 'fa-phone-square'},
        {icon: 'fa-photo', label: 'fa-photo'},
        {icon: 'fa-picture-o', label: 'fa-picture-o'},
        {icon: 'fa-pied-piper', label: 'fa-pied-piper'},
        {icon: 'fa-pied-piper-alt', label: 'fa-pied-piper-alt'},
        {icon: 'fa-pied-piper-square', label: 'fa-pied-piper-square'},
        {icon: 'fa-pinterest', label: 'fa-pinterest'},
        {icon: 'fa-pinterest-square', label: 'fa-pinterest-square'},
        {icon: 'fa-plane', label: 'fa-plane'},
        {icon: 'fa-play', label: 'fa-play'},
        {icon: 'fa-play-circle', label: 'fa-play-circle'},
        {icon: 'fa-play-circle-o', label: 'fa-play-circle-o'},
        {icon: 'fa-plus', label: 'fa-plus'},
        {icon: 'fa-plus-circle', label: 'fa-plus-circle'},
        {icon: 'fa-plus-square', label: 'fa-plus-square'},
        {icon: 'fa-plus-square-o', label: 'fa-plus-square-o'},
        {icon: 'fa-power-off', label: 'fa-power-off'},
        {icon: 'fa-print', label: 'fa-print'},
        {icon: 'fa-puzzle-piece', label: 'fa-puzzle-piece'},
        {icon: 'fa-qq', label: 'fa-qq'},
        {icon: 'fa-qrcode', label: 'fa-qrcode'},
        {icon: 'fa-question', label: 'fa-question'},
        {icon: 'fa-question-circle', label: 'fa-question-circle'},
        {icon: 'fa-quote-left', label: 'fa-quote-left'},
        {icon: 'fa-quote-right', label: 'fa-quote-right'},
        {icon: 'fa-ra', label: 'fa-ra'},
        {icon: 'fa-random', label: 'fa-random'},
        {icon: 'fa-rebel', label: 'fa-rebel'},
        {icon: 'fa-recycle', label: 'fa-recycle'},
        {icon: 'fa-reddit', label: 'fa-reddit'},
        {icon: 'fa-reddit-square', label: 'fa-reddit-square'},
        {icon: 'fa-refresh', label: 'fa-refresh'},
        {icon: 'fa-renren', label: 'fa-renren'},
        {icon: 'fa-reorder', label: 'fa-reorder'},
        {icon: 'fa-repeat', label: 'fa-repeat'},
        {icon: 'fa-reply', label: 'fa-reply'},
        {icon: 'fa-reply-all', label: 'fa-reply-all'},
        {icon: 'fa-retweet', label: 'fa-retweet'},
        {icon: 'fa-rmb', label: 'fa-rmb'},
        {icon: 'fa-road', label: 'fa-road'},
        {icon: 'fa-rocket', label: 'fa-rocket'},
        {icon: 'fa-rotate-left', label: 'fa-rotate-left'},
        {icon: 'fa-rotate-right', label: 'fa-rotate-right'},
        {icon: 'fa-rouble', label: 'fa-rouble'},
        {icon: 'fa-rss', label: 'fa-rss'},
        {icon: 'fa-rss-square', label: 'fa-rss-square'},
        {icon: 'fa-rub', label: 'fa-rub'},
        {icon: 'fa-ruble', label: 'fa-ruble'},
        {icon: 'fa-rupee', label: 'fa-rupee'},
        {icon: 'fa-save', label: 'fa-save'},
        {icon: 'fa-scissors', label: 'fa-scissors'},
        {icon: 'fa-search', label: 'fa-search'},
        {icon: 'fa-search-minus', label: 'fa-search-minus'},
        {icon: 'fa-search-plus', label: 'fa-search-plus'},
        {icon: 'fa-send', label: 'fa-send'},
        {icon: 'fa-send-o', label: 'fa-send-o'},
        {icon: 'fa-share', label: 'fa-share'},
        {icon: 'fa-share-alt', label: 'fa-share-alt'},
        {icon: 'fa-share-alt-square', label: 'fa-share-alt-square'},
        {icon: 'fa-share-square', label: 'fa-share-square'},
        {icon: 'fa-share-square-o', label: 'fa-share-square-o'},
        {icon: 'fa-shield', label: 'fa-shield'},
        {icon: 'fa-shopping-cart', label: 'fa-shopping-cart'},
        {icon: 'fa-sign-in', label: 'fa-sign-in'},
        {icon: 'fa-sign-out', label: 'fa-sign-out'},
        {icon: 'fa-signal', label: 'fa-signal'},
        {icon: 'fa-sitemap', label: 'fa-sitemap'},
        {icon: 'fa-skype', label: 'fa-skype'},
        {icon: 'fa-slack', label: 'fa-slack'},
        {icon: 'fa-sliders', label: 'fa-sliders'},
        {icon: 'fa-smile-o', label: 'fa-smile-o'},
        {icon: 'fa-sort', label: 'fa-sort'},
        {icon: 'fa-sort-alpha-asc', label: 'fa-sort-alpha-asc'},
        {icon: 'fa-sort-alpha-desc', label: 'fa-sort-alpha-desc'},
        {icon: 'fa-sort-amount-asc', label: 'fa-sort-amount-asc'},
        {icon: 'fa-sort-amount-desc', label: 'fa-sort-amount-desc'},
        {icon: 'fa-sort-asc', label: 'fa-sort-asc'},
        {icon: 'fa-sort-desc', label: 'fa-sort-desc'},
        {icon: 'fa-sort-down', label: 'fa-sort-down'},
        {icon: 'fa-sort-numeric-asc', label: 'fa-sort-numeric-asc'},
        {icon: 'fa-sort-numeric-desc', label: 'fa-sort-numeric-desc'},
        {icon: 'fa-sort-up', label: 'fa-sort-up'},
        {icon: 'fa-soundcloud', label: 'fa-soundcloud'},
        {icon: 'fa-space-shuttle', label: 'fa-space-shuttle'},
        {icon: 'fa-spinner', label: 'fa-spinner'},
        {icon: 'fa-spoon', label: 'fa-spoon'},
        {icon: 'fa-spotify', label: 'fa-spotify'},
        {icon: 'fa-square', label: 'fa-square'},
        {icon: 'fa-square-o', label: 'fa-square-o'},
        {icon: 'fa-stack-exchange', label: 'fa-stack-exchange'},
        {icon: 'fa-stack-overflow', label: 'fa-stack-overflow'},
        {icon: 'fa-star', label: 'fa-star'},
        {icon: 'fa-star-half', label: 'fa-star-half'},
        {icon: 'fa-star-half-empty', label: 'fa-star-half-empty'},
        {icon: 'fa-star-half-full', label: 'fa-star-half-full'},
        {icon: 'fa-star-half-o', label: 'fa-star-half-o'},
        {icon: 'fa-star-o', label: 'fa-star-o'},
        {icon: 'fa-steam', label: 'fa-steam'},
        {icon: 'fa-steam-square', label: 'fa-steam-square'},
        {icon: 'fa-step-backward', label: 'fa-step-backward'},
        {icon: 'fa-step-forward', label: 'fa-step-forward'},
        {icon: 'fa-stethoscope', label: 'fa-stethoscope'},
        {icon: 'fa-stop', label: 'fa-stop'},
        {icon: 'fa-strikethrough', label: 'fa-strikethrough'},
        {icon: 'fa-stumbleupon', label: 'fa-stumbleupon'},
        {icon: 'fa-stumbleupon-circle', label: 'fa-stumbleupon-circle'},
        {icon: 'fa-subscript', label: 'fa-subscript'},
        {icon: 'fa-suitcase', label: 'fa-suitcase'},
        {icon: 'fa-sun-o', label: 'fa-sun-o'},
        {icon: 'fa-superscript', label: 'fa-superscript'},
        {icon: 'fa-support', label: 'fa-support'},
        {icon: 'fa-table', label: 'fa-table'},
        {icon: 'fa-tablet', label: 'fa-tablet'},
        {icon: 'fa-tachometer', label: 'fa-tachometer'},
        {icon: 'fa-tag', label: 'fa-tag'},
        {icon: 'fa-tags', label: 'fa-tags'},
        {icon: 'fa-tasks', label: 'fa-tasks'},
        {icon: 'fa-taxi', label: 'fa-taxi'},
        {icon: 'fa-tencent-weibo', label: 'fa-tencent-weibo'},
        {icon: 'fa-terminal', label: 'fa-terminal'},
        {icon: 'fa-text-height', label: 'fa-text-height'},
        {icon: 'fa-text-width', label: 'fa-text-width'},
        {icon: 'fa-th', label: 'fa-th'},
        {icon: 'fa-th-large', label: 'fa-th-large'},
        {icon: 'fa-th-list', label: 'fa-th-list'},
        {icon: 'fa-thumb-tack', label: 'fa-thumb-tack'},
        {icon: 'fa-thumbs-down', label: 'fa-thumbs-down'},
        {icon: 'fa-thumbs-o-down', label: 'fa-thumbs-o-down'},
        {icon: 'fa-thumbs-o-up', label: 'fa-thumbs-o-up'},
        {icon: 'fa-thumbs-up', label: 'fa-thumbs-up'},
        {icon: 'fa-ticket', label: 'fa-ticket'},
        {icon: 'fa-times', label: 'fa-times'},
        {icon: 'fa-times-circle', label: 'fa-times-circle'},
        {icon: 'fa-times-circle-o', label: 'fa-times-circle-o'},
        {icon: 'fa-tint', label: 'fa-tint'},
        {icon: 'fa-toggle-down', label: 'fa-toggle-down'},
        {icon: 'fa-toggle-left', label: 'fa-toggle-left'},
        {icon: 'fa-toggle-right', label: 'fa-toggle-right'},
        {icon: 'fa-toggle-up', label: 'fa-toggle-up'},
        {icon: 'fa-trash-o', label: 'fa-trash-o'},
        {icon: 'fa-tree', label: 'fa-tree'},
        {icon: 'fa-trello', label: 'fa-trello'},
        {icon: 'fa-trophy', label: 'fa-trophy'},
        {icon: 'fa-truck', label: 'fa-truck'},
        {icon: 'fa-try', label: 'fa-try'},
        {icon: 'fa-tumblr', label: 'fa-tumblr'},
        {icon: 'fa-tumblr-square', label: 'fa-tumblr-square'},
        {icon: 'fa-turkish-lira', label: 'fa-turkish-lira'},
        {icon: 'fa-twitter', label: 'fa-twitter'},
        {icon: 'fa-twitter-square', label: 'fa-twitter-square'},
        {icon: 'fa-umbrella', label: 'fa-umbrella'},
        {icon: 'fa-underline', label: 'fa-underline'},
        {icon: 'fa-undo', label: 'fa-undo'},
        {icon: 'fa-university', label: 'fa-university'},
        {icon: 'fa-unlink', label: 'fa-unlink'},
        {icon: 'fa-unlock', label: 'fa-unlock'},
        {icon: 'fa-unlock-alt', label: 'fa-unlock-alt'},
        {icon: 'fa-unsorted', label: 'fa-unsorted'},
        {icon: 'fa-upload', label: 'fa-upload'},
        {icon: 'fa-usd', label: 'fa-usd'},
        {icon: 'fa-user', label: 'fa-user'},
        {icon: 'fa-user-md', label: 'fa-user-md'},
        {icon: 'fa-users', label: 'fa-users'},
        {icon: 'fa-video-camera', label: 'fa-video-camera'},
        {icon: 'fa-vimeo-square', label: 'fa-vimeo-square'},
        {icon: 'fa-vine', label: 'fa-vine'},
        {icon: 'fa-vk', label: 'fa-vk'},
        {icon: 'fa-volume-down', label: 'fa-volume-down'},
        {icon: 'fa-volume-off', label: 'fa-volume-off'},
        {icon: 'fa-volume-up', label: 'fa-volume-up'},
        {icon: 'fa-warning', label: 'fa-warning'},
        {icon: 'fa-wechat', label: 'fa-wechat'},
        {icon: 'fa-weibo', label: 'fa-weibo'},
        {icon: 'fa-weixin', label: 'fa-weixin'},
        {icon: 'fa-wheelchair', label: 'fa-wheelchair'},
        {icon: 'fa-windows', label: 'fa-windows'},
        {icon: 'fa-won', label: 'fa-won'},
        {icon: 'fa-wordpress', label: 'fa-wordpress'},
        {icon: 'fa-wrench', label: 'fa-wrench'},
        {icon: 'fa-xing', label: 'fa-xing'},
        {icon: 'fa-xing-square', label: 'fa-xing-square'},
        {icon: 'fa-yahoo', label: 'fa-yahoo'},
        {icon: 'fa-yen', label: 'fa-yen'},
        {icon: 'fa-youtube', label: 'fa-youtube'},
        {icon: 'fa-youtube-play', label: 'fa-youtube-play'},
        {icon: 'fa-youtube-square', label: 'fa-youtube-square'},
        {icon: null, label: '---'},
      ],
    };
  },
};
